import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import * as jose from 'jose'

interface IUser {
  IdUsuario?: number
  IdCliente?: number
  Nome?: string
  LoginUsuario?: string
  Ativo?: boolean
  IdAcesso?: number
}

interface IAuthState {
  isValid: boolean
  token: string
  user: IUser | null
  sessionTimeoutSeconds: number
  loginTimestamp: number | null
}

const initialState: IAuthState = {
  isValid: false,
  token: '',
  user: null,
  sessionTimeoutSeconds:  Number(process.env.SESSION_TIMEOUT_SECONDS),
  loginTimestamp: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<{
      token: string
    }>) {
      state.token = action.payload.token;
      if (action.payload.token) {
        try {
          const decoded = jose.decodeJwt(action.payload.token) as IUser;
          state.user = decoded;
          state.isValid = true;
        } catch (error) {
          state.user = null;
          state.isValid = false;
        }
      } else {
        state.user = null;
        state.isValid = false;
      }
    },
    setSessionConfig(state, action: PayloadAction<{
      timeout: number,
      timestamp?: number
    }>) {
      state.sessionTimeoutSeconds = action.payload.timeout;
      if (action.payload.timestamp) {
        state.loginTimestamp = action.payload.timestamp;
      }
    },
    resetAuthState(state) {
      state.isValid = false;
      state.token = '';
      state.user = null;
      state.loginTimestamp = null;
    }
  },
});

export const { setToken, setSessionConfig, resetAuthState } = authSlice.actions;
export const authReducer = authSlice.reducer;